// extracted by mini-css-extract-plugin
module.exports = {"label":"PieTooltip_label__3yicn","value":"PieTooltip_value__310zL","wrapper":"PieTooltip_wrapper__23jcp"};